<template>
	<div class="navbar">
		<div class="nav_tit">
			<!-- <p>宝鸡市优化建设项目环境影响评价分类管理试点信息填报系统</p> -->
			<img src="@/assets/images/navtitle.jpg" alt="">
		</div>
		<!-- <div class="nav_right">
			<div class="nav_user">
				<div class="nav_name">{{this.$store.state.user.name?this.$store.state.user.name:"admin"}}</div>
				<div class="nav_lagout" @click="logout">
					<i class="el-icon-switch-button" style="vertical-align: middle; margin-right: 3px"></i>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
import {
	mapGetters
} from "vuex";
export default {
	data() {
		return {
			img: "",
			hosname: "",
			newrole: "",
			currentTime: new Date(),
			week: "",
		};
	},
	components: {},
	computed: {
		...mapGetters(["sidebar", "name", "avatar", "device", "hid", "roles"]),
	},
	mounted() {
		var t = null;
		t = setTimeout(time, 1000); //開始运行
		function time() {
			clearTimeout(t); //清除定时器
			this.currentTime = new Date().toLocaleTimeString();
			if (document.getElementById("currTime")) {
				document.getElementById("currTime").innerHTML = this.currentTime;
			}
			t = setTimeout(time, 1000); //设定定时器，循环运行
		}
		this.getWeekDate();
	},
	methods: {
		// 当天是周几
		getWeekDate() {
			var now = new Date();
			var day = now.getDay();
			var weeks = new Array(
				"星期天",
				"星期一",
				"星期二",
				"星期三",
				"星期四",
				"星期五",
				"星期六"
			);
			this.week = weeks[day];
		},
		logout() {
			// this.$router.push("/login");
			this.$confirm("确认退出登录?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$store
						.dispatch("LogOut")
						.then(() => {
							this.$router.push("/");
						})
						.catch((err) => {
							console.log(err);
						});
				})
				.catch(() => { });
		},
	},
};
</script>

<style scoped lang="less">
.navbar {
	width: auto;
	height: 100px;
	line-height: 100px;

	.nav_tit {
		width: auto;
		height: 100%;

		img {
			height: 90%;
			vertical-align: middle;
		}

		p {
			line-height: 100px;
			color: #064FBD;
			font-size: 26px;
			letter-spacing: 3px;
			padding: 0 20px;
			box-sizing: border-box;
		}
	}

	// .nav_right {
	// 	width: 100px;
	// 	height: 100%;
	// 	line-height: 50px;


	// 	.nav_user {
	// 		//   flex: 1;
	// 		margin-right: 45px;
	// 		display: flex;
	// 		flex-direction: row;
	// 		justify-content: flex-end;
	// 		align-items: center;
	// 		color: #fff;
	// 		font-size: 15px;

	// 		.nav_lagout {
	// 			margin-left: 10px;
	// 			cursor: pointer;
	// 		}
	// 	}
	// }
}

@media (max-width:500px) {
	.navbar {
		height: 50px;
		line-height: 50px;

		.nav_tit {
			width: auto;
			height: 100%;

			img {
				height: 80%;
				vertical-align: middle;
			}

			p {
				line-height: 50px;
				font-size: 16px;
				letter-spacing: 0px;
				padding: 0 0 0 10px;
			}
		}
	}
}
</style>